var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelayedData = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E1E1",
  d: "M9 14a5.98 5.98 0 0 1-4.128-1.646l-.642.77A7 7 0 1 0 2 8H0l2.5 3.999L5 8H3a6 6 0 1 1 6 6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E1E1",
  d: "M8 5h1v4h3v1H8z"
})));
export default SvgDelayedData;